import React from "react";
import "./input.css";

/**
 * Select — native dropdown styled like Input (12px body text, shared borders).
 *
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.background - Field background ('default' | 'white')
 * @param {boolean} props.error - Validation error state
 */
const Select = React.forwardRef(
  (
    {
      className = "",
      background = "default",
      error = false,
      children,
      ...rest
    },
    ref
  ) => {
    const backgroundClass = background === "white" ? "ui-input--white" : "";
    const errorClass = error ? "ui-input--error" : "";

    return (
      <select
        ref={ref}
        className={`ui-input ui-select ${backgroundClass} ${errorClass} ${className}`
          .replace(/\s+/g, " ")
          .trim()}
        {...rest}
      >
        {children}
      </select>
    );
  }
);

Select.displayName = "Select";

export default Select;
